import { render, staticRenderFns } from "./CentroEmplazamientos.vue?vue&type=template&id=9631005a&scoped=true"
import script from "./CentroEmplazamientos.vue?vue&type=script&lang=js"
export * from "./CentroEmplazamientos.vue?vue&type=script&lang=js"
import style0 from "./CentroEmplazamientos.vue?vue&type=style&index=0&id=9631005a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9631005a",
  null
  
)

export default component.exports